import {
  store,
  getContext,
  getElement,
} from '@wordpress/interactivity';
import { NAMESPACE } from './constants';
import { PERF_MARKS } from './DataView/constants';

store(NAMESPACE, {
  state: {
  },

  actions: {
  },

  callbacks: {
    init: async () => {
      performance.mark(PERF_MARKS.INIT_START);

      console.debug(`[filterableTabularData.init] Loading...`);
      
      const { ref: rootEl } = getElement();
      const context = getContext();

      const datasheetConfig = context?.datasheetConfig || null;
      const headerCellNoWrap = context?.headerCellNoWrap || false;
      const dataCellNoWrap = context?.dataCellNoWrap || false;
      const showOverflowShadows = context?.showOverflowShadows || false;
      const stickyHeader = context?.stickyHeader || false;
      const rawTableStyles = context?.tableStyles || null;
      // Create a plain copy to unwrap from Interactivity API Proxy
      const tableStyles = rawTableStyles ? { ...rawTableStyles } : null;
      const tableClasses = context?.tableClasses || null;
      console.debug('[filterableTabularData.init] Datasheet Config:', datasheetConfig);
      console.debug('[filterableTabularData.init] Table Styles:', tableStyles);
      console.debug('[filterableTabularData.init] Table Classes:', tableClasses);

      // Dynamically load the DataView module and initialize it
      const { initializeDataView } = await import('efi-data-dataview-module');
      
      initializeDataView(rootEl, {
        datasheetConfig,
        headerCellNoWrap,
        dataCellNoWrap,
        showOverflowShadows,
        stickyHeader,
        tableStyles,
        tableClasses,
      });

      console.debug(`[filterableTabularData.init] Loaded.`);
    },
  }
});
